﻿<div class="route-component">
    <div class="form-component">
        <h4 *ngIf="batchId === 0">
            Create Ageing Import Batch
        </h4>

        <form #form="ngForm" (ngSubmit)="onSave(form)">

            <div class="input-group">
                <auto-complete-dropdown
                    [options]="periods"
                    [label]="'Period'"
                    [placeholder]="'Select a period...'"
                    [initialValue]="selectedPeriodId"
                    [required]="true"
                    [invalid]="!selectedPeriodId"
                    [validationMessage]="'Period is required'"
                    [displayWith]="displayPeriod"
                    (selectionChange)="onPeriodSelectionChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="input-group">
                <auto-complete-dropdown
                    [options]="clients"
                    [label]="'Client'"
                    [placeholder]="'Select a client...'"
                    [initialValue]="selectedClientId"
                    [required]="true"
                    [invalid]="!selectedClientId"
                    [validationMessage]="'Client is required'"
                    (selectionChange)="onClientSelectionChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="input-group">
                <label for="fileInput">
                    Ageing File:<span class="required"> * </span>
                </label>
                <div>
                    <label for="fileInput" class="custom-file-label" [class.invalid]="fileControl.invalid">
                        {{ selectedFileName || 'Choose a file' }}
                    </label>
                    <input id="fileInput" name="fileControl" ngModel #fileControl="ngModel" type="file" class="custom-file-input" accept=".xlsx" (change)="onFileSelected($event)" required/>
                    <div *ngIf="fileControl.invalid">
                        <span class="error">Ageing file is required</span>
                    </div>
                </div>
            </div>

            <div class="action-bar">
                <button type="submit" class="button"
                    [class.button-progress]="isSaving"
                    [style.--progress]="uploadProgress + '%'"
                    [disabled]="
                    !selectedPeriodId ||
                    !selectedClientId ||
                    form.invalid || isSaving">
                    <span *ngIf="isSaving" class="progress-percent">{{ uploadProgress }}%</span>
                    <i *ngIf="!isSaving" class="fas fa-save"></i>
                    {{ isSaving ? uploadMessage : 'Save' }}
                </button>
                <button type="button" class="button-cancel" (click)="onCancel()" [disabled]="isSaving">
                    <i class="fas fa-cancel"></i> Cancel
                </button>
            </div>
        </form>
    </div>
</div>